import { generateKeys } from '../utils';
export const personalIdNamePerCountry = generateKeys({
    ar: {
        value: 'AR',
        label: 'Argentina',
        pid: {
            idLabel1: 'Documento Nacional de Identidad (DNI)',
            idLabel2: 'Clave Única de Identificación Tributaria (CUIT)',
        },
        nationalId2Name: 'TaxIDNumber',
    },
    bh: {
        value: 'BH',
        label: 'Bahrain',
        pid: { idLabel1: 'Identity Card Number' },
    },
    bd: {
        value: 'BD',
        label: 'Bangladesh',
        pid: { idLabel1: 'National Identity Card Number' },
    },
    ba: {
        value: 'BA',
        label: 'Bosnia And Herzegovina',
    },
    br: {
        value: 'BR',
        label: 'Brazil',
        pid: { idLabel1: 'Cadastro de Pessoas Físicas (CPF)' },
    },
    td: {
        value: 'TD',
        label: 'Chad',
    },
    cl: {
        value: 'CL',
        label: 'Chile',
        pid: { idLabel1: 'Rol Único Nacional (RUN) / Rol Único Tributario (RUT)' },
    },
    cn: {
        value: 'CN',
        label: 'China',
        pid: { idLabel1: 'Personal Identification Number' },
    },
    co: {
        value: 'CO',
        label: 'Colombia',
        pid: { idLabel1: 'Número Único de Identidad Personal (NUIP)' },
    },
    cr: {
        value: 'CR',
        label: 'Costa Rica',
        pid: { idLabel1: 'Cédula de Identidad' },
    },
    dk: {
        value: 'DK',
        label: 'Denmark',
        pid: { idLabel1: 'Personal Identification Number' },
    },
    do: {
        value: 'DO',
        label: 'Dominican Republic',
        pid: { idLabel1: 'Cédula de Identidad' },
    },
    ec: {
        value: 'EC',
        label: 'Ecuador',
        pid: { idLabel1: 'Registro Único del Contribuyente (RUC)' },
    },
    eg: {
        value: 'EG',
        label: 'Egypt',
        pid: { idLabel1: 'بطاقة تحقيق شخصية' },
    },
    sv: {
        value: 'SV',
        label: 'El Salvador',
        pid: {
            idLabel1: 'Numero de Identificacion Tributaria (SV-NIT) / Documento Único de Identidad (DUI)',
        },
    },
    fi: {
        value: 'FI',
        label: 'Finland',
        pid: { idLabel1: 'Personal Identification Number' },
    },
    ge: {
        value: 'GE',
        label: 'Georgia',
        pid: { idLabel1: 'ეროვნული პირადობის მოწმობა' },
    },
    gh: {
        value: 'GH',
        label: 'Ghana',
        pid: {
            idLabel1: 'Social Security Number (SSNIT)',
            idLabel2: `Voter's ID Card Number`,
        },
        nationalId2Name: 'VoterID',
    },
    hk: {
        value: 'HK',
        label: 'Hong Kong',
        pid: { idLabel1: 'Hong Kong Identity Card Number (HKID)' },
    },
    in: {
        value: 'IN',
        label: 'India',
        pid: {
            idLabel1: 'Permanent Account Number (PAN)',
            idLabel2: 'Driving License',
        },
        nationalIdName: 'TaxFileNumber',
        nationalId2Name: 'DriverLicenceNumber',
    },
    id: {
        value: 'ID',
        label: 'Indonesia',
        pid: { idLabel1: 'National ID Card (NIK)' },
    },
    il: {
        value: 'IL',
        label: 'Israel',
        pid: { idLabel1: 'Mispar Zehut' },
    },
    it: {
        value: 'IT',
        label: 'Italy',
        pid: { idLabel1: 'Personal Identification Number' },
    },
    jo: {
        value: 'JO',
        label: 'Jordan',
        pid: { idLabel1: 'بطاقة شخصية' },
    },
    ke: {
        value: 'KE',
        label: 'Kenya',
        pid: {
            idLabel1: 'National Identity Card Number',
            idLabel2: 'Passport Number',
        },
        nationalId2Name: 'PassportNumber',
    },
    kw: {
        value: 'KW',
        label: 'Kuwait',
        pid: { idLabel1: 'State of Kuwait Civil ID Card Number' },
    },
    lb: {
        value: 'LB',
        label: 'Lebanon',
        pid: { idLabel1: 'Identity Card Number' },
    },
    my: {
        value: 'MY',
        label: 'Malaysia',
        pid: { idLabel1: 'National Registration Identity Card Number (NRIC)' },
        nationalIdName: 'NRIC Number',
    },
    mx: {
        value: 'MX',
        label: 'Mexico',
        pid: {
            idLabel1: 'Clave Única de Registro de Población (CURP)',
            idLabel2: 'Registro Federal de Contribuyentes (RFC)',
        },
        nationalIdName: 'CURPIDNumber',
        nationalId2Name: 'MxRFCNumber',
    },
    ng: {
        value: 'NG',
        label: 'Nigeria',
        pid: {
            idLabel1: 'National Identity Card Number',
            idLabel2: 'Voter\'s ID Card Number',
        },
        nationalId2Name: 'VoterID',
    },
    pe: {
        value: 'PE',
        label: 'Peru',
        pid: {
            idLabel1: 'Documento Nacional de Identidad (DNI) / Código Único de Identificación (CUI)',
        },
    },
    ph: {
        value: 'PH',
        label: 'Philippines',
        pid: {
            idLabel1: 'Philippine Identification System ID (PhilSys)',
            idLabel2: 'Social Security Number (SSN)',
        },
        nationalId2Name: 'SocialSecurityNumber',
    },
    pl: {
        value: 'PL',
        label: 'Poland',
        pid: { idLabel1: 'Personal Identification Number' },
    },
    qa: {
        value: 'QA',
        label: 'Qatar',
        pid: { idLabel1: 'State of Qatar ID Card Number (QID)' },
    },
    sa: {
        value: 'SA',
        label: 'Saudi Arabia',
        pid: { idLabel1: 'National ID Card Number' },
    },
    sg: {
        value: 'SG',
        label: 'Singapore',
        pid: { idLabel1: 'National Registration ID Card Number (NRIC)' },
        nationalIdName: 'NricNumber',
    },
    za: {
        value: 'ZA',
        label: 'South Africa',
        pid: { idLabel1: 'National Identity Card Number' },
    },
    es: {
        value: 'ES',
        label: 'Spain',
        pid: { idLabel1: 'Personal Identification Number' },
    },
    sj: {
        value: 'SJ',
        label: 'Svalbard And Jan Mayen',
    },
    se: {
        value: 'SE',
        label: 'Sweden',
        pid: { idLabel1: 'Personal Identification Number' },
    },
    ua: {
        value: 'UA',
        label: 'Ukraine',
        pid: { idLabel1: 'Taxpayer Identification Number' },
    },
    uy: {
        value: 'UY',
        label: 'Uruguay',
        pid: { idLabel1: 'Registro Unico Tributario (RUT)' },
    },
    ve: {
        value: 'VE',
        label: 'Venezuela',
        pid: { idLabel1: 'Número de Registro Único de Información Fiscal (RIF)' },
    },
    tr: {
        value: 'TR',
        label: 'Turkey',
        pid: { idLabel1: 'Turkish Identification Number (T.C. Kimlik Numarası)' },
    },
});
